module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-box"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('serviceTerms')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('acceptTermsDes')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('acceptTermsDescribe')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('usagePolicy')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('usagePolicyDes')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('usagePolicyExplain')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('usagePolicyDescribe')))]), _vm._v(" "), _vm._l((_vm.$t('dutyList')), function(duty, index) {
    return _c('p', {
      staticClass: "account-lists"
    }, [_c('span', {
      staticClass: "index"
    }), _vm._v(_vm._s(duty) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "violations"
  }, [_vm._v(_vm._s(_vm.$t('violations')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('termsChange')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('termsChangeDes')))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65b3c02a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacyService/PrivacyService.vue
// module id = 1339
// module chunks = 1